module.exports = __webpack_public_path__ + "img/mmb.1ac7d0d6.png";